<!-- Mod Toolbar - Ölçüm aracı tarzında -->
<div class="mod-toolbar">
  @for (kat of kategoriler; track kat.value) {
  <button class="mod-btn"
          [class.active]="kategori === kat.value"
          [style.--active-color]="kat.renk"
          (click)="secKategori(kat.value)"
          [title]="kat.label">
    <span class="mod-icon">{{kat.ikon}}</span>
  </button>
  }
</div>

<!-- Custom İkon Input -->
<div class="icon-row">
  <span class="icon-label">İkon:</span>
  <input type="text" [(ngModel)]="customIkon"
         placeholder="Emoji, numara, yazı..."
         class="icon-input"
         maxlength="4"
         (ngModelChange)="onizlemeGuncelle()">
  <span class="icon-preview" [style.color]="aktifRenk">
    {{customIkon || secilenKategori?.ikon}}
  </span>
</div>

<!-- Renk Seçiciler (kompakt) -->
<div class="color-row">
  <span class="color-label">Renk:</span>
  <input type="color"
         class="color-picker"
         [ngModel]="ozelRenk || secilenKategori?.renk || '#2196F3'"
         (ngModelChange)="ozelRenk=$event; onizlemeGuncelle()"
         title="Nokta rengi">
  <button class="color-reset" (click)="ozelRenk=''; onizlemeGuncelle()"
          [class.hidden]="!ozelRenk" title="Varsayılana dön">×</button>
  <span class="color-sep">|</span>
  <span class="color-label">Yazı:</span>
  <input type="color"
         class="color-picker color-text"
         [ngModel]="yaziRenk || '#FFFFFF'"
         (ngModelChange)="yaziRenk=$event; onizlemeGuncelle()"
         title="Yazı rengi">
  <button class="color-reset" (click)="yaziRenk=''; onizlemeGuncelle()"
          [class.hidden]="!yaziRenk" title="Varsayılana dön">×</button>
</div>

<div class="divider"></div>

<!-- Düzenleme Modu Başlığı -->
@if (duzenlemeModu) {
<div class="edit-header">
  <span class="edit-icon">✏️</span>
  <span class="edit-title">Düzenleme Modu</span>
</div>
}

<!-- Konum Seçimi (hem yeni ekleme hem düzenleme modunda) -->
<div class="status-row">
  <span class="status-label">Konum:</span>
  <span class="status-value" [class.selected]="noktaPozisyonu">
    {{noktaPozisyonu ? 'Seçildi ✓' : 'Seçilmedi'}}
  </span>
  <button class="pick-btn" (click)="pozisyonSec()" [disabled]="secimModu"
          [title]="duzenlemeModu ? 'Yeni konum seç' : 'Konum seç'">
    <i class="icon crosshairs"></i>
  </button>
</div>

<!-- Başlık Input -->
<div class="input-row">
  <input type="text" [(ngModel)]="baslik" placeholder="Başlık..."
         class="title-input" (ngModelChange)="onizlemeGuncelle()">
</div>

<!-- Açıklama Input (Tooltip için) -->
<div class="input-row">
  <textarea [(ngModel)]="aciklama" placeholder="Açıklama (hover'da görünür)..."
            class="desc-input" rows="2" (ngModelChange)="onizlemeGuncelle()"></textarea>
</div>

<div class="divider"></div>

<!-- Boyut Ayarı (12-240 arası) -->
<div class="size-row">
  <span class="size-label">Nokta:</span>
  <input type="range" [(ngModel)]="boyut" min="12" max="240" step="4"
         class="size-slider" (ngModelChange)="onizlemeGuncelle()">
  <span class="size-value">{{boyut}}</span>
</div>

<!-- Pencere Boyutu (50-400 arası) -->
<div class="size-row">
  <span class="size-label">Pencere:</span>
  <input type="range" [(ngModel)]="pencereBoyut" min="50" max="400" step="10"
         class="size-slider" (ngModelChange)="onizlemeGuncelle()">
  <span class="size-value">{{pencereBoyut}}</span>
</div>

<!-- Ayarlar -->
<div class="options-row">
  <label class="opt" title="Zoom bağımsız boyut">
    <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="onizlemeGuncelle()">
    <span>Sabit</span>
  </label>
  <label class="opt" title="Etiket her zaman görünsün">
    <input type="checkbox" [(ngModel)]="etiketGorunsun" (ngModelChange)="onizlemeGuncelle()">
    <span>Etiket</span>
  </label>
  <label class="opt" title="Halka animasyonu">
    <input type="checkbox" [(ngModel)]="animasyonAktif" (ngModelChange)="onizlemeGuncelle()">
    <span>Anim</span>
  </label>
</div>

<div class="divider"></div>

<!-- Kamera Konumu Kontrolü (sadece düzenleme modunda veya nokta seçildiyse) -->
@if (duzenlemeModu || noktaPozisyonu) {
<div class="camera-row">
  <span class="camera-label">Kamera:</span>
  <div class="camera-buttons">
    <button class="cam-btn cam-save" (click)="kameraKonumuKaydet()" title="Mevcut kamera konumunu kaydet">
      <span>Kaydet</span>
    </button>
    <button class="cam-btn cam-goto" (click)="kameraKonumunaGit()"
            [disabled]="!kameraKonumuVar" title="Kaydedilen konuma git">
      <span>Git</span>
    </button>
    <button class="cam-btn cam-clear" (click)="kameraKonumuTemizle()"
            [disabled]="!kameraKonumuVar" title="Kamera konumunu temizle">
      <span>Sil</span>
    </button>
  </div>
  @if (kameraKonumuVar) {
    <span class="cam-status saved">Kayitli</span>
  }
</div>
<div class="divider"></div>
}

<!-- ═══════════════════════════════════════════════════════════════════════ -->
<!-- PROFESYONEl CAD ÖZELLİKLERİ -->
<!-- ═══════════════════════════════════════════════════════════════════════ -->

<!-- Profesyonel Özellikler Toggle Bar -->
<div class="pro-features-bar">
  <span class="pro-label">PRO:</span>
  <button class="pro-toggle pro-only-toggle" [class.active]="proOnlyMod" (click)="proOnlyMod=!proOnlyMod; onizlemeGuncelle()" title="PRO-only: SmartPoint ikonunu gizle, sadece PRO badge'leri göster">
    <span>◉</span>
  </button>
  <span class="pro-sep">|</span>
  <button class="pro-toggle" [class.active]="leaderAktif" (click)="leaderAktif=!leaderAktif; onizlemeGuncelle()" title="Leader Line">
    <span>↗</span>
  </button>
  <button class="pro-toggle" [class.active]="gdtAktif" (click)="gdtAktif=!gdtAktif; onizlemeGuncelle()" title="GD&T">
    <span>⌖</span>
  </button>
  <button class="pro-toggle" [class.active]="yuzeyKaliteAktif" (click)="yuzeyKaliteAktif=!yuzeyKaliteAktif; onizlemeGuncelle()" title="Yüzey Kalitesi">
    <span>▽</span>
  </button>
  <button class="pro-toggle" [class.active]="kaynakAktif" (click)="kaynakAktif=!kaynakAktif; onizlemeGuncelle()" title="Kaynak Sembolü">
    <span>△</span>
  </button>
  <span class="pro-sep">|</span>
  <button class="pro-toggle" [class.active]="datumAktif" (click)="datumAktif=!datumAktif; onizlemeGuncelle()" title="Datum Marker">
    <span>Ⓐ</span>
  </button>
  <button class="pro-toggle" [class.active]="dimensionAktif" (click)="dimensionAktif=!dimensionAktif; onizlemeGuncelle()" title="Ölçü Çizgisi">
    <span>↔</span>
  </button>
</div>

<!-- Leader Line Ayarları -->
@if (leaderAktif) {
<div class="pro-section leader-section">
  <div class="pro-section-header">
    <span class="pro-section-icon">↗</span>
    <span class="pro-section-title">Leader Line</span>
  </div>
  <div class="pro-row">
    <select [(ngModel)]="leaderTip" (ngModelChange)="onizlemeGuncelle()" class="pro-select">
      <option value="straight">Düz</option>
      <option value="bent">Kırık</option>
    </select>
    <select [(ngModel)]="leaderYon" (ngModelChange)="onizlemeGuncelle()" class="pro-select" title="Yön">
      @for (y of yonSecenekleri; track y.value) {
        <option [value]="y.value">{{y.label}}</option>
      }
    </select>
    <input type="color" [(ngModel)]="leaderRenk" (ngModelChange)="onizlemeGuncelle()"
           class="pro-color" title="Çizgi rengi">
  </div>
  <div class="pro-row">
    <span class="pro-label-mini">Uzunluk:</span>
    <input type="number" [(ngModel)]="leaderUzunluk" min="1" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number" title="Leader uzunluğu">
    <span class="pro-label-mini">Kalınlık:</span>
    <input type="number" [(ngModel)]="leaderKalinlik" min="1" max="5" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number" title="Çizgi kalınlığı">
  </div>
  <div class="pro-row pro-offset-row">
    <span class="pro-label-mini">Offset:</span>
    <span class="pro-label-mini">X:</span>
    <input type="number" [(ngModel)]="leaderOffsetX" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="X offset">
    <span class="pro-label-mini">Y:</span>
    <input type="number" [(ngModel)]="leaderOffsetY" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="Y offset">
  </div>
</div>
}

<!-- GD&T Ayarları -->
@if (gdtAktif) {
<div class="pro-section gdt-section">
  <div class="pro-section-header">
    <span class="pro-section-icon">⌖</span>
    <span class="pro-section-title">GD&T</span>
    <label class="pro-check-header" title="Şeffaf arka plan">
      <input type="checkbox" [(ngModel)]="gdtSeffafArkaplan" (ngModelChange)="onizlemeGuncelle()">
      <span>Şeffaf</span>
    </label>
  </div>
  <div class="pro-row">
    <select [(ngModel)]="gdtTip" (ngModelChange)="onizlemeGuncelle()" class="pro-select gdt-select">
      <optgroup label="Form">
        <option value="flatness">⏥ Düzlük</option>
        <option value="straightness">⏤ Doğrusallık</option>
        <option value="circularity">○ Dairesellik</option>
        <option value="cylindricity">⌭ Silindiriklik</option>
      </optgroup>
      <optgroup label="Yönelim">
        <option value="parallelism">∥ Paralellik</option>
        <option value="perpendicularity">⊥ Diklik</option>
        <option value="angularity">∠ Açısallık</option>
      </optgroup>
      <optgroup label="Konum">
        <option value="position">⌖ Konum</option>
        <option value="concentricity">◎ Eşmerkezlilik</option>
        <option value="symmetry">≡ Simetri</option>
      </optgroup>
      <optgroup label="Salınım">
        <option value="runout">↗ Salınım</option>
        <option value="totalRunout">⇗ Toplam Salınım</option>
      </optgroup>
    </select>
  </div>
  <div class="pro-row">
    <input type="text" [(ngModel)]="gdtDeger" (ngModelChange)="onizlemeGuncelle()"
           class="pro-input" placeholder="Tolerans (0.05)">
    <input type="text" [(ngModel)]="gdtDatum" (ngModelChange)="onizlemeGuncelle()"
           class="pro-input" placeholder="Datum (A)">
    <select [(ngModel)]="gdtMalzemeKosulu" (ngModelChange)="onizlemeGuncelle()" class="pro-select-mini">
      <option value="">-</option>
      <option value="M">Ⓜ MMC</option>
      <option value="L">Ⓛ LMC</option>
      <option value="S">Ⓢ RFS</option>
    </select>
  </div>
  <div class="pro-row pro-offset-row">
    <span class="pro-label-mini">Offset:</span>
    <span class="pro-label-mini">X:</span>
    <input type="number" [(ngModel)]="gdtOffsetX" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="X offset">
    <span class="pro-label-mini">Y:</span>
    <input type="number" [(ngModel)]="gdtOffsetY" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="Y offset">
    <span class="pro-label-mini">3D:</span>
    <select [(ngModel)]="gdtDuzlem" (ngModelChange)="onizlemeGuncelle()" class="pro-select-sm" title="3D Düzlem Seçimi">
      @for (d of duzlemSecenekleri; track d.value) {
        <option [value]="d.value">{{d.label}}</option>
      }
    </select>
  </div>
</div>
}

<!-- Yüzey Kalitesi Ayarları -->
@if (yuzeyKaliteAktif) {
<div class="pro-section yuzey-section">
  <div class="pro-section-header">
    <span class="pro-section-icon">▽</span>
    <span class="pro-section-title">Yüzey Kalitesi</span>
    <label class="pro-check-header" title="Şeffaf arka plan">
      <input type="checkbox" [(ngModel)]="yuzeySeffafArkaplan" (ngModelChange)="onizlemeGuncelle()">
      <span>Şeffaf</span>
    </label>
  </div>
  <div class="pro-row">
    <select [(ngModel)]="yuzeyKaliteTip" (ngModelChange)="onizlemeGuncelle()" class="pro-select">
      <option value="machined">▽ İşlenmiş</option>
      <option value="ground">▽▽ Taşlanmış</option>
      <option value="lapped">▽▽▽ Alıştırılmış</option>
      <option value="polished">◇ Parlatılmış</option>
      <option value="cast">〰 Döküm</option>
      <option value="forged">⌇ Dövme</option>
    </select>
    <input type="number" [(ngModel)]="yuzeyRa" min="0.1" max="50" step="0.1"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number" placeholder="Ra (µm)">
  </div>
  <div class="pro-row pro-offset-row">
    <span class="pro-label-mini">Offset:</span>
    <span class="pro-label-mini">X:</span>
    <input type="number" [(ngModel)]="yuzeyOffsetX" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="X offset">
    <span class="pro-label-mini">Y:</span>
    <input type="number" [(ngModel)]="yuzeyOffsetY" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="Y offset">
    <span class="pro-label-mini">3D:</span>
    <select [(ngModel)]="yuzeyDuzlem" (ngModelChange)="onizlemeGuncelle()" class="pro-select-sm" title="3D Düzlem Seçimi">
      @for (d of duzlemSecenekleri; track d.value) {
        <option [value]="d.value">{{d.label}}</option>
      }
    </select>
  </div>
</div>
}

<!-- Kaynak Sembolü Ayarları -->
@if (kaynakAktif) {
<div class="pro-section kaynak-section">
  <div class="pro-section-header">
    <span class="pro-section-icon">△</span>
    <span class="pro-section-title">Kaynak</span>
    <label class="pro-check-header" title="Şeffaf arka plan">
      <input type="checkbox" [(ngModel)]="kaynakSeffafArkaplan" (ngModelChange)="onizlemeGuncelle()">
      <span>Şeffaf</span>
    </label>
  </div>
  <div class="pro-row">
    <select [(ngModel)]="kaynakTip" (ngModelChange)="onizlemeGuncelle()" class="pro-select">
      <option value="fillet">△ Köşe</option>
      <option value="groove">V Oluk</option>
      <option value="plug">▢ Tıpa</option>
      <option value="spot">● Nokta</option>
      <option value="seam">═ Dikiş</option>
      <option value="surfacing">▬ Yüzey</option>
    </select>
    <input type="text" [(ngModel)]="kaynakBoyut" (ngModelChange)="onizlemeGuncelle()"
           class="pro-input" placeholder="Boyut">
  </div>
  <div class="pro-row">
    <label class="pro-check">
      <input type="checkbox" [(ngModel)]="kaynakTamCevre" (ngModelChange)="onizlemeGuncelle()">
      <span>○ Tam Çevre</span>
    </label>
    <label class="pro-check">
      <input type="checkbox" [(ngModel)]="kaynakSahada" (ngModelChange)="onizlemeGuncelle()">
      <span>▸ Sahada</span>
    </label>
  </div>
  <div class="pro-row pro-offset-row">
    <span class="pro-label-mini">Offset:</span>
    <span class="pro-label-mini">X:</span>
    <input type="number" [(ngModel)]="kaynakOffsetX" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="X offset">
    <span class="pro-label-mini">Y:</span>
    <input type="number" [(ngModel)]="kaynakOffsetY" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="Y offset">
    <span class="pro-label-mini">3D:</span>
    <select [(ngModel)]="kaynakDuzlem" (ngModelChange)="onizlemeGuncelle()" class="pro-select-sm" title="3D Düzlem Seçimi">
      @for (d of duzlemSecenekleri; track d.value) {
        <option [value]="d.value">{{d.label}}</option>
      }
    </select>
  </div>
</div>
}

<!-- Datum Marker Ayarları -->
@if (datumAktif) {
<div class="pro-section datum-section">
  <div class="pro-section-header">
    <span class="pro-section-icon">Ⓐ</span>
    <span class="pro-section-title">Datum Marker</span>
    <label class="pro-check-header" title="Şeffaf arka plan">
      <input type="checkbox" [(ngModel)]="datumSeffafArkaplan" (ngModelChange)="onizlemeGuncelle()">
      <span>Şeffaf</span>
    </label>
  </div>
  <div class="pro-row">
    <select [(ngModel)]="datumTip" (ngModelChange)="onizlemeGuncelle()" class="pro-select">
      <option value="A">A</option>
      <option value="B">B</option>
      <option value="C">C</option>
      <option value="D">D</option>
      <option value="E">E</option>
      <option value="F">F</option>
      <option value="custom">Özel</option>
    </select>
    @if (datumTip === 'custom') {
      <input type="text" [(ngModel)]="datumCustomLabel" (ngModelChange)="onizlemeGuncelle()"
             class="pro-input" placeholder="Etiket" maxlength="3">
    }
    <input type="color" [(ngModel)]="datumRenk" (ngModelChange)="onizlemeGuncelle()"
           class="pro-color" title="Renk">
  </div>
  <div class="pro-row">
    <label class="pro-check">
      <input type="checkbox" [(ngModel)]="datumUcgenGoster" (ngModelChange)="onizlemeGuncelle()">
      <span>▼ Üçgen Göster</span>
    </label>
  </div>
  <div class="pro-row pro-offset-row">
    <span class="pro-label-mini">Offset:</span>
    <span class="pro-label-mini">X:</span>
    <input type="number" [(ngModel)]="datumOffsetX" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="X offset">
    <span class="pro-label-mini">Y:</span>
    <input type="number" [(ngModel)]="datumOffsetY" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="Y offset">
    <span class="pro-label-mini">3D:</span>
    <select [(ngModel)]="datumDuzlem" (ngModelChange)="onizlemeGuncelle()" class="pro-select-sm" title="3D Düzlem Seçimi">
      @for (d of duzlemSecenekleri; track d.value) {
        <option [value]="d.value">{{d.label}}</option>
      }
    </select>
  </div>
</div>
}

<!-- Dimension Line (Ölçü Çizgisi) Ayarları -->
@if (dimensionAktif) {
<div class="pro-section dimension-section">
  <div class="pro-section-header">
    <span class="pro-section-icon">↔</span>
    <span class="pro-section-title">Ölçü Çizgisi</span>
    <label class="pro-check-header" title="Şeffaf arka plan">
      <input type="checkbox" [(ngModel)]="dimensionSeffafArkaplan" (ngModelChange)="onizlemeGuncelle()">
      <span>Şeffaf</span>
    </label>
  </div>
  <div class="pro-row">
    <select [(ngModel)]="dimensionTip" (ngModelChange)="onizlemeGuncelle()" class="pro-select">
      <option value="linear">— Doğrusal</option>
      <option value="diameter">Ø Çap</option>
      <option value="radius">R Yarıçap</option>
      <option value="angle">∠ Açı</option>
    </select>
    <input type="text" [(ngModel)]="dimensionDeger" (ngModelChange)="onizlemeGuncelle()"
           class="pro-input" placeholder="Değer (4.489)">
  </div>
  <div class="pro-row">
    <input type="text" [(ngModel)]="dimensionToleransUst" (ngModelChange)="onizlemeGuncelle()"
           class="pro-input" placeholder="+ Tol (+.010)">
    <input type="text" [(ngModel)]="dimensionToleransAlt" (ngModelChange)="onizlemeGuncelle()"
           class="pro-input" placeholder="- Tol (-.010)">
  </div>
  <div class="pro-row">
    <select [(ngModel)]="dimensionBirim" (ngModelChange)="onizlemeGuncelle()" class="pro-select-mini">
      <option value="mm">mm</option>
      <option value="in">in</option>
      <option value="°">°</option>
    </select>
    <select [(ngModel)]="dimensionOkTip" (ngModelChange)="onizlemeGuncelle()" class="pro-select-mini">
      <option value="arrow">→ Ok</option>
      <option value="dot">● Nokta</option>
      <option value="slash">/ Çizgi</option>
      <option value="none">Yok</option>
    </select>
  </div>
  <div class="pro-row">
    <span class="pro-label-mini">Uzunluk:</span>
    <input type="number" [(ngModel)]="dimensionUzunluk" min="1" max="100" step="1"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number" title="Ölçü çizgisi uzunluğu">
  </div>
  <div class="pro-row pro-offset-row">
    <span class="pro-label-mini">Offset:</span>
    <span class="pro-label-mini">X:</span>
    <input type="number" [(ngModel)]="dimensionOffsetX" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="X offset">
    <span class="pro-label-mini">Y:</span>
    <input type="number" [(ngModel)]="dimensionOffsetY" min="-50" max="50" step="0.5"
           (ngModelChange)="onizlemeGuncelle()" class="pro-number-sm" title="Y offset">
    <span class="pro-label-mini">3D:</span>
    <select [(ngModel)]="dimensionDuzlem" (ngModelChange)="onizlemeGuncelle()" class="pro-select-sm" title="3D Düzlem Seçimi">
      @for (d of duzlemSecenekleri; track d.value) {
        <option [value]="d.value">{{d.label}}</option>
      }
    </select>
  </div>
</div>
}

<div class="divider"></div>

<!-- Sonuç Bilgisi -->
@if (noktaPozisyonu) {
<div class="result-box">
  <div class="result-row">
    <span class="result-icon">{{secilenKategori?.ikon}}</span>
    <span class="result-title">{{baslik || 'Nokta'}}</span>
  </div>
  <div class="result-coords">
    X: {{noktaPozisyonu.x.toFixed(2)}} &nbsp;
    Y: {{noktaPozisyonu.y.toFixed(2)}} &nbsp;
    Z: {{noktaPozisyonu.z.toFixed(2)}}
  </div>
</div>
}

<div class="divider"></div>

<!-- Alt Butonlar -->
<div class="footer-row">
  @if (duzenlemeModu) {
    <!-- Düzenleme modu butonları -->
    <button class="btn-save" (click)="duzenlemeKaydet()">
      Kaydet
    </button>
    <button class="btn-delete" (click)="noktaSil()">
      Sil
    </button>
    <button class="btn-cancel" (click)="duzenlemeyiIptal()">
      İptal
    </button>
  } @else {
    <!-- Normal mod butonları -->
    <button class="btn-add" (click)="ekle()" [disabled]="!eklemeAktif">
      Ekle
    </button>
    <button class="btn-close" (click)="kapat()">
      Kapat
    </button>
  }
</div>
